import Trainings from './List'
import Training from './Training'

export { Training }

export default Trainings
